import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import mainRoutes from '../component/routes/routes';
import SideBar from '../component/SideBar/SideBar';
import TopBar from '../component/TopBar/TopBar';
import { ClientService } from '../component/services/client.service';
import { useAllowedPages } from '../context/AllowedPagesContext';




export default function PrivateRoutes() {

    const { setAllowedPages } = useAllowedPages();

    async function getAllowedPages() {

        await ClientService.getAllowedPages()
            .then((res) => {
                if (res.status === 200) {
                    console.log("Allowed pages fetched successfully", res.data.data.allowedPages);
                    if (res.data.data.allowedPages && Array.isArray(res.data.data.allowedPages)) {
                        setAllowedPages(res.data.data.allowedPages);
                    }
                }
            })
            .catch((err) => {
                console.error("Failed to fetch allowed pages", err);
            });
    }

    useEffect(() => {
        getAllowedPages();
    }, []);

    return (
        <>
            <TopBar
                // menuData={mainRoutes}
                // panelName="User"
            />

            <Container>
                <Outlet />
            </Container>
        </>
    )
}